<template>
  <div class="contact-container">
    <div class="contact-buttons">
      <div class="contact-button" @mouseenter="showTikTokQR = true" @mouseleave="showTikTokQR = false">
        <div class="contact-icon">
          <img src="../assets/images/tiktok-icon.png" alt="TikTok">
        </div>
      </div>
      <div class="contact-button" @mouseenter="showWeChatQR = true" @mouseleave="showWeChatQR = false">
        <div class="contact-icon">
          <img src="../assets/images/wechat-icon.png" alt="WeChat">
        </div>
      </div>
      <div class="contact-button" @click="openContactForm">
        <div class="contact-icon">
          <img src="../assets/images/contact-icon.png" alt="Contact">
        </div>
      </div>
    </div>
    
    <!-- TikTok QR码 -->
    <div class="qr-code-container" :class="{ 'show': showTikTokQR }">
      <div class="qr-code">
        <img src="../assets/images/tiktok-qr.jpg" alt="TikTok QR Code">
        <!-- <p>TikTok</p> -->
      </div>
    </div>

    <!-- WeChat QR码 -->
    <div class="qr-code-container" :class="{ 'show': showWeChatQR }">
      <div class="qr-code">
        <img src="../assets/images/wechat-qr.png" alt="WeChat QR Code">
        <!-- <p>WeChat</p> -->
      </div>
    </div>

    <!-- Add the ContactFormModal component here -->
    <ContactFormModal ref="contactFormModal" />
  </div>
</template>

<script>
import ContactFormModal from '@/components/ContactFormModal.vue';

export default {
  name: 'Contact',
  components: {
    ContactFormModal  // Register the component
  },
  data() {
    return {
      showTikTokQR: false,
      showWeChatQR: false,
      showContactInfo: false
    }
  },
  methods: {
    openContactForm() {
      // Update to use v-show approach instead of jQuery's show()
      this.$emit('open-contact-form');
    },
    handleContactClick() {
      console.log('Contact clicked');
    }
  }
}
</script>

<style scoped>
.contact-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.contact-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contact-button {
  background-color: transparent;  /* 移除背景色 */
  color: white;
  padding: 0.5rem;  /* 减小内边距，让图标更好地填充空间 */
  width: 50px;      /* 设置固定宽度 */
  height: 50px;     /* 设置固定高度，保持正方形 */
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;    /* 使用flex布局使图标居中 */
  align-items: center;
  justify-content: center;
}

.contact-icon {
  width: 40px;   /* 增加图标尺寸 */
  height: 40px;  /* 保持宽高比 */
}

.contact-icon img {
  height: 100%;
  object-fit: contain;
}

.qr-code-container {
  background-color: white;
  padding: 0.2rem;  /* 减小内边距 */
  border-radius: 8px 0 0 8px;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  opacity: 0;
  transition: all 0.3s ease;
  position: absolute;
  right: 100%;
  pointer-events: none;
  height: 170px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code {
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;  /* 移除内边距 */
}

.qr-code img {
  width: 165px;    /* 增加图片尺寸以填充容器 */
  height: 165px;   /* 增加图片尺寸以填充容器 */
  object-fit: contain;
  border: 1px solid rgba(224, 224, 224, 0.5);
  border-radius: 3px;
  padding: 1px;
}

.qr-code-container.show {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 5px;
}

.qr-code p {
  margin-top: 0.5rem;
  font-weight: 500;
  color: #2c3e50;
}

.contact-info {
  background-color: white;
  padding: 1.5rem;
  border-radius: 10px 0 0 10px;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  opacity: 0;
  transition: all 0.3s ease;
  position: absolute;
  right: 100%;
  pointer-events: none;
  min-width: 200px;
}

.contact-info.show {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.contact-info h3 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.contact-area {
  background-color: #3498db;
  color: white;
  padding: 1rem;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-area:hover {
  background-color: #2980b9;
}

.contact-button:hover {
  background-color: rgba(52, 152, 219, 0.1);  /* 鼠标悬停时显示淡蓝色背景 */
}
</style>